// extracted by mini-css-extract-plugin
module.exports = {"mt20":"mt20-3yyKjNRp"};